import CRUDReducer from './CRUDReducer';
import playersCRUDActions from '../actions/player';

const playersCRUDReducer = new CRUDReducer(playersCRUDActions);

export default (state, action) => playersCRUDReducer.run(state, action);



// WEBPACK FOOTER //
// ./src/reducers/player.js